import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store.js'
import "./assets/chartist.scss";
import "./assets/style.scss";

import Pagination from '@/components/Pagination.vue'
Vue.component('pagination', Pagination)

import CompareDates from '@/components/CompareDates.vue'
Vue.component('compare-dates', CompareDates)

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
Vue.component('vue-dropzone', vue2Dropzone)

//import chartist from 'chartist'
//Vue.use(chartist)

Vue.config.productionTip = false

Vue.use(require('vue-chartist'))

Vue.mixin({
    methods: {
        capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
        formatCurrency: str => (str ? new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(str) : '0.00'),
        formatInteger: str => (str ? new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(str) : '0'),
        notEmpty: obj => typeof obj === 'object' && Object.keys(obj).length !== 0,
        compareObjects: (a, b) => {
            // Create arrays of property names
            var aProps = Object.getOwnPropertyNames(a)
            var bProps = Object.getOwnPropertyNames(b)

            // If number of properties is different,
            // objects are not equivalent
            if (aProps.length != bProps.length) {
                return false;
            }

            for (var i = 0; i < aProps.length; i++) {
                var propName = aProps[i];
                // skip the __ob__ property
                if (propName == '__ob__') { continue }
                if (propName == 'page') { continue }
                // If values of same property are not equal,
                // objects are not equivalent
                if (a[propName] !== b[propName]) {
                    return false;
                }
            }

            // If we made it this far, objects
            // are considered equivalent
            return true
        },
        getYesterdaysDate: str => {
            let fullYear = sessionStorage.getItem('report_year') || (new Date()).getFullYear()
            var today = new Date()
            var date = str || new Date()
            if (fullYear == today.getFullYear()) {
                date.setDate(date.getDate()-1)
            } else {
                date.setFullYear(fullYear)
                date.setMonth(11)
                date.setDate(31)
            }
            return date.getFullYear() + '-' + String(date.getMonth()+1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0')
        },
        getTodaysDate: str => {
            var date = str || new Date()
            return date.getFullYear() + '-' + String(date.getMonth()+1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0')
        },
        getYearStartDate: str => {
            let fullYear = sessionStorage.getItem('report_year') || (new Date()).getFullYear()
            return fullYear  + '-01-01'
        },
        getQueryString: str => {
            let queryString = new URLSearchParams(window.location.search)
            for (let pair of queryString) {
                if (pair[0] == str) {
                    return pair[1]
                }
            }
            return null
        }
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
